import React from 'react'
import PropTypes from 'prop-types'
import {components} from 'react-select'

function Option(props) {
  const {
    innerProps: {innerRef, ...innerProps},
  } = props
  const progress =
    props.data.tasksTotal > 0 ? `${props.data.tasksDone} / ${props.data.tasksTotal}` : `${props.data.tasksDone}`
  if (props === undefined) {
    return null
  }
  return (
    <div ref={innerRef} {...innerProps}>
      <div className="react-select__option__wrap">
        <components.Option {...props}>
          <span>{props.children}</span>
          <div className="react-select__progress">{progress}</div>
        </components.Option>
      </div>
    </div>
  )
}

Option.propTypes = {
  data: PropTypes.object,
  innerRef: PropTypes.any,
  innerProps: PropTypes.any,
  children: PropTypes.any,
}

export default Option
